import React, {useState} from 'react';
import * as Queries from './Queries';
import { useQuery } from "@apollo/client";

import Loading from 'components/Loading/Page';
import Error from 'components/Error/Page';
import MaskPrice from 'functions/mask/price';


import { Col, Row, Layout, Table, Typography, Button} from 'antd';

import {statuses} from './Misc';

const { Content } = Layout;
const { Title } = Typography;



function Users(props) {

	  const { loading, data, error, refetch } = useQuery(Queries.USERS, {
	  	fetchPolicy: 'no-cache',
	  	variables: {
	  		filters: {
	  			status: '3'
	  		}
	  	}
	  });

	  const columns = [
	    {
	      title: 'Nome',
	      dataIndex: 'name',
	      key: 'name',
	    },
	    {
	      title: 'Email',
	      dataIndex: 'email',
	      key: 'email',
	    },
	    {
	      title: 'Fone',
	      dataIndex: 'phone',
	      key: 'phone',
	    },
	    {
	      title: 'CPF',
	      dataIndex: 'cpf',
	      key: 'cpf',
	    },
	    {
	      title: 'Status',
	      dataIndex: 'status',
	      key: 'status',
	      render: (status) => {
	      	return statuses[status];
	      }
	    },
	    {
	      title: 'Ações',
	      dataIndex: '',
	      key: 'x',
	      render: (value, row) => {
	      	return <Button type="link"
	      	onClick={() => {
	      		props.history.push(`/user/${row._id}`)
	      	}}
	      	>
	      	  Editar
	      	</Button>
	      },
	    },
	  ];

	  return (
	   		  		<Layout className={'page-wrapper'}>
	   			  		<Content className="site-layout-background">

	   			  		  <div className="page-title">
	   			  		  	<Title>Abertura de MEI</Title>
	   			  		  </div>

	   			  		  <div className="dashboard">

	   			  		  	{loading ? (
	   			  		  		<Loading/>
	   			  		  	) : null}


	   			  		  	{
	   			  		  		(!loading && !error && data) ? (

	   			  		  			<div>
	   			  		  				<Table 
	   			  		  					rowKey="_id" 
	   			  		  					dataSource={data.Users.length ? data.Users : []}
	   			  		  					columns={columns} 
	   			  		  				/>
	   			  		  			</div>

	   			  		  		) : null
	   			  		  	}

	   			  		  	{
	   			  		  		(!loading && error) ? (
	   			  		  			<Error
	   			  		  				refetch={() => refetch()}
	   			  		  			/>
	   			  		  		) : null
	   			  		  	}

	   			  		  	
	   			  		  </div>
	   			  		</Content>
	   		  		</Layout>
	  );
}

export default Users;
